import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { HttpIntercepted } from './http/http.intercepted';
import { CompaniaService } from './services/compania.service';
import { CiudadService } from './services/ciudad.service';
import { SedeService } from './services/sede.service';
import { ListaItemService } from './services/lista-item.service';
import { VlanService } from './services/vlan.service';
import { TipoAsignacionService } from './services/tipo-asignacion.service';
import { AdministradorIpService } from './services/administrador-ip.service';
import { SesionService } from './services/sesion.service';
import { InicioService } from './services/inicio.service';
import { AsignacionService } from './services/asignacion.service';
import { VlanSedeService } from './services/vlanSede.service';
import { SuperNetService } from './services/supernet.service';
import { SeusStatusService } from './services/seus-status.service';
import { SeusAvailabilityGuard } from './guards/seus-availability.guard';

@NgModule({
  imports: [
    CommonModule,
    NgbModule
  ],
  declarations: [],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SharedModule,
      providers: [
        SeusStatusService,
        {
          provide: HTTP_INTERCEPTORS,
          useClass: HttpIntercepted,
          multi: true
        },
        CompaniaService,
        CiudadService,
        SedeService,
        ListaItemService,
        VlanService,
        TipoAsignacionService,
        AdministradorIpService,
        SesionService,
        InicioService,
        AsignacionService,
        VlanSedeService,
        SuperNetService,
        SeusAvailabilityGuard
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/shared.module.ts